import { Component, Input, OnInit } from '@angular/core';
import { SurveyRespondentService } from '../../../api/services/survey-respondent.service';
import { SurveyRespondentModel } from '../../../api/models/survey-respondent-model';
import { AuthService } from '../../../services/auth.service';
import { Ethnicity } from '../../../enums/ethnicity';
import { KeyValue } from '@angular/common';
import { ToastService } from '../../../services/toast.service';
import { Gender } from '../../../enums/gender';

@Component({
  selector: 'app-respondent-details-form',
  templateUrl: './respondent-details-form.component.html',
  styleUrls: ['./respondent-details-form.component.scss'],
  standalone: false,
})
export class RespondentDetailsFormComponent implements OnInit {
  customGender?: string | null = null;
  originalCustomEthnicity?: string | null = null;
  customEthnicity?: string | null = null;
  editing: boolean = false;

  @Input({ required: true })
  surveyRespondentDetails!: SurveyRespondentModel;
  protected readonly Ethnicity = Ethnicity;
  protected readonly Gender = Gender;

  constructor(
    private surveyRespondentService: SurveyRespondentService,
    private authService: AuthService,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    // Handle custom genders
    if (
      this.surveyRespondentDetails.gender &&
      !Object.values(Gender).includes(
        this.surveyRespondentDetails.gender as Gender,
      )
    ) {
      this.customGender = this.surveyRespondentDetails.gender;
      this.surveyRespondentDetails.gender = Gender.selfDescribe;
    }

    // Handle custom ethnicities
    if (this.surveyRespondentDetails.ethnicities.includes(Ethnicity.other)) {
      this.customEthnicity = this.surveyRespondentDetails.ethnicities.filter(
        (e) => !Object.values(Ethnicity).includes(e as Ethnicity),
      )[0];
      this.originalCustomEthnicity = this.customEthnicity;
    }
  }

  updateRespondent() {
    if (!this.surveyRespondentDetails) {
      return;
    }

    let ethnicities = this.surveyRespondentDetails.ethnicities;
    if (this.customEthnicity) {
      if (this.originalCustomEthnicity) {
        ethnicities = ethnicities.filter(
          (e) => e !== this.originalCustomEthnicity,
        );
      }
      ethnicities.push(this.customEthnicity);
    }

    this.surveyRespondentService
      .surveyRespondentsPut(this.authService.getAuthorisationHeaders(), {
        surveyRespondentGuid: this.surveyRespondentDetails.guid!,
        body: {
          firstName: this.surveyRespondentDetails.firstName,
          lastName: this.surveyRespondentDetails.lastName,
          mobileNumber: this.surveyRespondentDetails.mobileNumber,
          emailAddress: this.surveyRespondentDetails.email,
          dateOfBirth: this.surveyRespondentDetails.dateOfBirth,
          ethnicities: ethnicities,
          gender:
            this.surveyRespondentDetails.gender === Gender.selfDescribe
              ? this.customGender
              : this.surveyRespondentDetails.gender,
        },
      })
      .subscribe({
        next: () => {
          this.toastService.success('Survey Respondent Updated');
          this.editing = false;
        },
      });
  }

  // eslint-disable-next-line
  protected unsorted(a: KeyValue<any, any>, b: KeyValue<any, any>): number {
    return 0;
  }
}
